import { useEffect, useState } from "react";
import Card from "antd/es/card/Card";
import { Formik, Form } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";

import { api } from "../../../api/url";

// --------------- component
import { InputField, InputWithPrefix, SelectField } from "../../../components";

// --------------- style
import "./style.css";

const WalletSchema = Yup.object().shape({
  bankCardNo: Yup.number()
    .typeError("فیلد کارت بانکی باید عدد باشد")
    .required("فیلد کارت بانکی الزامی می‌باشد"),
  bankShebaNo: Yup.number()
    .typeError("فیلد شماره شبا باید عدد باشد")
    .required("فیلد شماره شبا الزامی می‌باشد"),
  bankId: Yup.mixed().required("فیلد نام‌بانک الزامی می‌باشد"),
});

const ProfileDetail = () => {
  const [banks, setBanks] = useState([]);
  const [bankInfo, setBankInfo] = useState({
    bankCardNo: "",
    bankShebaNo: "",
    bankId: null,
  });

  const GetBankInfo = async () => {
    await axios({
      method: "get",
      url: api + "appointment/user/getbankinfo/" + localStorage.getItem("user"),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        setBankInfo({ ...res.data.data, bankId: res.data.data.bankId || null });
        // setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const GetBanksList = async () => {
    await axios({
      method: "get",
      url: api + "appointment/bank/list",
    })
      .then((res) => {
        setBanks(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const UpdateBankInfo = async (values, setSubmitting) => {
    await axios({
      method: "put",
      url: api + "appointment/user/updatebankinfo/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: {
        bankId: values.bankId,
        bankShebaNo: values.bankShebaNo,
        bankCardNo: values.bankCardNo,
        userId: localStorage.getItem("user"),
      },
    })
      .then((res) => {
        toast.success("ویرایش اطلاعات بانکی با موفقیت انجام شد!");

        setSubmitting(false);
        // setData(res.data.data);
      })
      .catch((err) => {
        toast.error("خطا در ویرایش اطلاعات بانکی");

        setSubmitting(false);
      });
  };

  useEffect(() => {
    GetBankInfo();
    GetBanksList();
  }, []);

  return (
    <Card>
      <Formik
        initialValues={bankInfo}
        enableReinitialize
        validationSchema={WalletSchema}
        onSubmit={(values, { setSubmitting }) => {
          UpdateBankInfo(values, setSubmitting);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="profile-field-section">
              <InputField
                inputClassname="wallet-bankcard"
                type={"number"}
                name="bankCardNo"
                title="شماره‌کارت"
              />

              <SelectField name="bankId" title="نام‌بانک" options={banks} />
            </div>

            <div className="profile-field-section">
              <InputWithPrefix
                type={"number"}
                prefix={"IR"}
                inputstyle={{ width: "100%" }}
                name="bankShebaNo"
                title="شماره شبا"
              />
            </div>

            <button
              className="submit-form-btn"
              type="submit"
              disabled={isSubmitting}
            >
              ثبت
            </button>
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default ProfileDetail;
